import { createSelector, Selector } from 'reselect';

import { RootState } from '@/model/types';

import { Bank } from './types';

export const makeSelectInitialized = (): Selector<RootState, boolean> =>
  createSelector(
    (state: RootState) => state.dictionary,
    (state) => state.initialized,
  );

export const makeSelectBanks = (): Selector<RootState, Bank[]> =>
  createSelector(
    (state: RootState) => state.dictionary,
    (state) => state.banks,
  );

const banksSelector = makeSelectBanks();
export const makeSelectBank = (id: string): Selector<RootState, Bank | undefined> =>
  createSelector(banksSelector, (state) =>
    state.find(({ id: saved, aliases }) => saved === id || aliases.includes(id)),
  );

export const makeSelectDefaultBank = (): Selector<RootState, Bank | undefined> => makeSelectBank('_');

export default {
  makeSelectInitialized,
  makeSelectDefaultBank,
  makeSelectBank,
  makeSelectBanks,
};
